export const safeRedirectPath = (
  input: string | null | undefined,
  fallback = '/dashboard',
): string => {
  if (!input) {
    return fallback;
  }

  const value = String(input).trim();
  if (!value.startsWith('/')) {
    return fallback;
  }

  if (value.startsWith('//') || value.includes('://') || value.includes('\\')) {
    return fallback;
  }

  return value;
};
